import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';

import { addCustomer, updateCustomer } from 'redux/actions/index';
import { cities } from 'constants/cities';

const CustomerDetails = (props) => {
  
  const [values, setValues] = useState({
    name: props.customerInfo.name,
    phone: props.customerInfo.phone,
    addressLine: props.customerInfo.addressLine,
    city: props.customerInfo.city,
    country: props.customerInfo.country,
    trn: props.customerInfo.trn
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if(props.update) {
      const updatedCustomer = {
        id: props.customerInfo.id,
        updates: {
          name: values.name,
          phone: values.phone,
          addressLine: values.addressLine,
          city: values.city,
          country: values.country
        }
      }
      props.updateCustomer(updatedCustomer);
    }
    else {
      const newCustomer = {
        displayId: props.customerInfo.displayId,
        name: values.name,
        phone: values.phone,
        addressLine: values.addressLine,
        city: values.city,
        country: values.country,
        ...( values.trn && {trn: values.trn} )
      };
      props.addCustomer(newCustomer, false, props.user.adminId);
    }
    
    props.cancelAddUpdate();
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited later"
          title="Customer"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the name"
                label="Name"
                name="name"
                onChange={handleChange}
                required
                value={values.name}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the Phone Number"
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                required
                value={values.phone}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the Address"
                label="Address"
                name="addressLine"
                onChange={handleChange}
                required
                value={values.addressLine}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please select the city"
                label="Select city"
                name="city"
                onChange={handleChange}
                select
                SelectProps={{ native: true }}
                value={values.city}
                variant="outlined"
              >
                {cities.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the Country"
                label="Country"
                name="country"
                onChange={handleChange}
                required
                value={values.country}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                disabled={props.update}
                fullWidth
                helperText="Please specify the Customer TRN"
                label="TRN"
                name="trn"
                onChange={handleChange}
                value={values.trn}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Save details
          </Button>
          <Button sx={{ mx: 1 }} onClick={props.cancelAddUpdate.bind(this)}>
            Cancel
          </Button>
        </Box>
      </Card>
    </form>
  )
};

export default connect (null, {addCustomer, updateCustomer}) (CustomerDetails);